import React, { useEffect, useState } from 'react';
import styles from './Blog.module.css';
import Post from './Post/Post';
import previousBtnImg from '../../../assets/images/mojo-login-img/pag-left-arrow-icon.svg';
import nextBtnImg from '../../../assets/images/mojo-login-img/pag-right-arrow-icon.svg';

export default function Blog() {
  const defaultData = [
    {
      id: 5548,
      title:
        'Why the Multi-Line Power Dialer Outperforms the Predictive Dialer.',
      content_html:
        'In the world of high-paced sales, dialers are indispensable tools for maximizing agent productivity. The two most popular options are the power dialer and the predictive dialer, each offering distinct advantages. However, when it comes to reducing call abandonment and ensuring agents greet leads at first ‘hello,’ multi-line power dialers come out on top. Here’s why a multi-line power dialer is often better, particularly for smaller sales teams and single agents',
      url: 'https://www.mojosells.com/blog/why-the-multi-line-power-dialer-outperforms-the-predictive-dialer/',
    },
    {
      id: 5528,
      title: '5 Reasons Why Whitelisted Caller ID Trumps Local Presence',
      content_html:
        'In the competitive landscape of outbound calling, making sure your calls are trusted and answered is more important than ever. Unlike Mojo, many companies turn to local presence caller ID systems in the hopes of increasing answer rates. These systems automatically assign local area codes to outgoing calls, creating the illusion of a local caller, and change them during the call session based on the volume of calls. While this might seem like a good way to gain trust and improve pick-up rates, it often does the opposite, particularly in today’s stringent regulatory and consumer trust environment where whitelisted caller ID shines.',
      url: 'https://www.mojosells.com/blog/whitelisted-caller-id-compared-to-local-presence/',
    },
  ];
  const [blogItems, setBlogItems] = useState(defaultData);
  const [currentIndex, setCurrentIndex] = useState(0);

  function decodeHtmlEntities(text) {
    const txt = document.createElement('textarea');
    txt.innerHTML = text;
    return txt.value;
  }

  useEffect(() => {
    const blogFeedUrl =
      'https://www.mojosells.com/blog/feed/json?num=5&date=n&desc=400&utf=y&pc=y';
    // Fetch data from the blog feed URL
    fetch(blogFeedUrl)
      .then((response) => response.json())
      .then((data) => {
        const cleaned = data.items.map((item) => ({
          ...item,
          title: decodeHtmlEntities(item.title),
          content_html: decodeHtmlEntities(item.content_html),
        }));
        setBlogItems(cleaned.slice(0, 6)); // Limiting to 6 items
      })
      .catch((error) => {
        console.log('Error fetching the blog feed:', error);
      });
  }, []);

  // Calculate the two posts to display
  const getVisiblePosts = () => {
    const firstPost = blogItems[currentIndex];
    const secondIndex = (currentIndex + 1) % blogItems.length; // Circular logic for the second post
    const secondPost = blogItems[secondIndex];
    return [firstPost, secondPost];
  };

  // Handle the "Next" button
  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % blogItems.length);
  };

  // Handle the "Previous" button
  const handlePrevious = () => {
    setCurrentIndex(
      (prevIndex) => (prevIndex - 1 + blogItems.length) % blogItems.length
    );
  };

  const visiblePosts = getVisiblePosts();

  return (
    <div>
      <div style={{ display: 'flex' }}>
        {visiblePosts.map((postItem) => (
          <Post item={postItem} key={postItem.id} />
        ))}
      </div>
      <div
        style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}
      >
        <button
          type="button"
          onClick={handlePrevious}
          className={styles.BlogBtn}
        >
          <img src={previousBtnImg} alt="" style={{ marginLeft: '6px' }} />
        </button>
        <button type="button" onClick={handleNext} className={styles.BlogBtn}>
          <img src={nextBtnImg} alt="" style={{ marginLeft: '6px' }} />
        </button>
      </div>
    </div>
  );
}
